import APP from 'src/main.js'
import AppRecord from './AppRecord.js'

class EventLoad extends AppRecord {

  get bankRecord(){
    return this.constructor.employeeStore.banks.find(bank => bank.name === this.bank)
  }

  get entity(){
    if (this.account){
      return this.account.entity
    } else if (this.deposit){
      return this.deposit.entity
    }

    return {}
  }

  get entityLongName(){
    if (this.entity){
      return this.entity.long_name
    }

    return ''
  }

  get account(){
    if (this.cachedAccount == null) {
      this.cachedAccount = this.constructor.employeeStore.accounts.find(a => a.accountid === Number(this.account_id) && a.bank_id === this.bankRecord?.id)
    }
    return this.cachedAccount
  }

  get account_name(){
    if(this.account){
      return this.account.name
    } else {
      return null
    }
  }

  get acc_id(){
    if(this.account){
      return this.account.id
    } else {
      return null
    }
  }

  get deposit(){
    if (this.cachedDeposit == null) {
      this.cachedDeposit = this.constructor.employeeStore.deposits.find(d => d.depositid === Number(this.deposit_id) && d.bank_id === this.bankRecord?.id)
    }
    return this.cachedDeposit
  }

  get deposit_name(){
    if(this.deposit){
      return this.deposit.name
    } else {
      return null
    }
  }

  get dep_id(){
    if(this.deposit){
      return this.deposit.id
    } else {
      return null
    }
  }

}

export default EventLoad
